import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import usePageTitle from "./hooks/usePageTitle";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Expertise from "./pages/Expertise";
import WhoWeAre from "./pages/WhoWeAre";
import References from "./pages/References";
import Contact from "./pages/Contact";
import VisionSourcing from "./pages/VisionSourcing";

// Component to use hooks inside Router
const AppContent = () => {
  usePageTitle();
  
  return (
    <>
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/vision-sourcing" element={<VisionSourcing />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/references" element={<References />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
